/* eslint-disable no-console */
<template>
    <div>
        <div class="header_unit header_bg_white">
            <div class="header_box">
                <div class="menu_left">
                    <router-link class="icn_back_black top_tit" :to="{ name: 'managemenu'} ">
                        <p class="top_tit">＜戻る</p></router-link>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_l top_tit">センサー情報一覧</p>
                </div>
            </div>
        </div>
        <SenserList />
    </div>

</template>

<script>
    import SenserList from '@/app/components/SenserList.vue'
    export default {
        name: 'manageSenserList',
        components: {
            SenserList
        }
    }
</script>
